import { render, staticRenderFns } from "./gobalFooter.vue?vue&type=template&id=64e62df6&scoped=true&"
import script from "./gobalFooter.vue?vue&type=script&lang=js&"
export * from "./gobalFooter.vue?vue&type=script&lang=js&"
import style0 from "./gobalFooter.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./gobalFooter.vue?vue&type=style&index=1&id=64e62df6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e62df6",
  null
  
)

export default component.exports